import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Landing from "@/pages/Landing";
import Insights from "@/pages/Insights";
import InsightDetail from "@/pages/InsightDetail";
import Legal from "@/pages/Legal";
import Privacidad from "@/pages/Privacidad";
import AdminLayout from "@/admin/AdminLayout";
import AdminDashboard from "@/admin/pages/AdminDashboard";
import AdminPosts from "@/admin/pages/AdminPosts";
import AdminLeads from "@/admin/pages/AdminLeads";
import AdminApplications from "@/admin/pages/AdminApplications";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/insights" element={<Insights />} />
          <Route path="/insights/:slug" element={<InsightDetail />} />
          <Route path="/legal" element={<Legal />} />
          <Route path="/privacidad" element={<Privacidad />} />
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<AdminDashboard />} />
            <Route path="posts" element={<AdminPosts />} />
            <Route path="leads" element={<AdminLeads />} />
            <Route path="applications" element={<AdminApplications />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster
        position="bottom-right"
        theme="dark"
        toastOptions={{
          style: {
            background: "#150A1F",
            color: "#F9F6F0",
            border: "1px solid #2A0A4A",
            borderRadius: "4px",
            fontFamily: "Manrope, sans-serif",
          },
        }}
      />
    </div>
  );
}

export default App;
